/**
 * OmniLeagues — AD Family Directory hub.
 *
 * Sub-tabs (like the Organizations hub):
 *   • Directory — one row per family (parents/contacts/children).
 *   • Players   — one row per player-season.
 *   • Birthdays — birthday tracker by season.
 *
 * All three read the SAME OL SOT (families / players.team_memberships) via the
 * existing /api/exports endpoints — no new collections. (migration_log_0124)
 */
import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Users, User, Cake } from 'lucide-react';

import FamilyDirectoryPanel from './FamilyDirectoryPanel';
import PlayersDirectoryPanel from './PlayersDirectoryPanel';
import BirthdayTrackerPanel from './BirthdayTrackerPanel';

const TABS = [
  { key: 'directory', label: 'Directory', icon: Users },
  { key: 'players',   label: 'Players',   icon: User },
  { key: 'birthdays', label: 'Birthdays', icon: Cake },
];

export default function FamilyDirectoryHubPanel({ orgId, teams, isDark }) {
  const [active, setActive] = useState('directory');

  if (!orgId) {
    return (
      <Card className={isDark ? 'bg-slate-800/50 border-slate-700' : 'bg-white border-slate-200'}>
        <CardContent className="p-6">
          <p className={isDark ? 'text-slate-400' : 'text-slate-500'}>No organization selected.</p>
        </CardContent>
      </Card>
    );
  }

  const navBg = isDark ? 'bg-slate-800/60 border-slate-700' : 'bg-white border-slate-200';
  const inactive = isDark
    ? 'text-slate-400 hover:text-white hover:bg-slate-700/40'
    : 'text-slate-500 hover:text-slate-900 hover:bg-slate-100';
  const activeCls = isDark
    ? 'bg-amber-600/20 text-amber-400 border-amber-500/40'
    : 'bg-amber-50 text-amber-700 border-amber-200';

  return (
    <div className="space-y-4" data-testid="family-directory-hub">
      <div className={`flex flex-wrap items-center gap-1 p-1.5 rounded-lg border ${navBg}`}
           data-testid="family-hub-tabs">
        {TABS.map(t => {
          const Icon = t.icon;
          const isActive = active === t.key;
          return (
            <Button key={t.key} variant="ghost" size="sm" onClick={() => setActive(t.key)}
                    className={`h-9 px-4 text-sm font-medium border ${isActive ? activeCls : 'border-transparent ' + inactive}`}
                    data-testid={`family-hub-tab-${t.key}`}>
              <Icon className="h-4 w-4 mr-2" />
              {t.label}
            </Button>
          );
        })}
      </div>

      {active === 'directory' && <FamilyDirectoryPanel orgId={orgId} teams={teams} isDark={isDark} />}
      {active === 'players'   && <PlayersDirectoryPanel orgId={orgId} isDark={isDark} />}
      {active === 'birthdays' && <BirthdayTrackerPanel orgId={orgId} teams={teams} isDark={isDark} />}
    </div>
  );
}
